import Tooltip from '@mui/material/Tooltip'
import Box from '@mui/material/Box'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const TextNote = ({ notes }) => 
  <Box className="box-center">
    { notes  ? (
      <Tooltip arrow title={notes}>
        <span>
          <FontAwesomeIcon
            icon='comment-dots'
            className="text-primary text-lg"
          />
        </span>
      </Tooltip>
    ) : (
      <FontAwesomeIcon
        className="text-primary text-lg opacity-25"
        icon='comment-dots'
      />
    )}
  </Box>

export default TextNote
